import { RoasterLogo } from "@bcc/components/roaster-logo";
import { UserNav } from "@bcc/components/user-nav";
import { setAppHeaderTestId } from "./app-header.utils";

interface AppHeaderProps {
  readonly testId?: string;
}

export function AppHeader({ testId }: AppHeaderProps) {
  return (
    <header
      data-testid={testId ?? setAppHeaderTestId("container")}
      className="sticky top-0 z-50 w-full border-b border-border-subtle bg-surface-1 shadow-sm print:hidden"
    >
      <div className="flex h-[72px] items-center gap-4 px-6">
        <div className="flex items-center gap-3">
          {/* BCC Logo */}
          <div className="flex items-center gap-2">
            <div className="relative h-16 w-auto">
              <img src="/images/bcc-logo.png" alt="Beanz Control Center" width={160} height={64} className="h-16 w-auto object-contain" />
            </div>
          </div>

          {/* Divider */}
          <div className="h-14 w-px bg-border-subtle" />

          {/* Roaster Logo */}
          <RoasterLogo />
        </div>

        {/* Right Actions */}
        <div className="ml-auto flex items-center gap-2">
          <UserNav />
        </div>
      </div>
    </header>
  );
}
